
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import moment, { Moment } from 'moment';
    import { Wait } from '@/__env/ext';
    import { MensajeAutomatico } from '@/__env/lib/Chats/MensajeAutomatico/MensajeAutomatico.nav';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Mensaje: MensajeAutomatico;

        public get Estado() { return this.Controlador.Vista.Estado; }
        public Contenido: string = '';
        public Activo: boolean = false;
        public UltimaModificacion: Moment = null;

        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
                this.Iniciar();
        }

        public Iniciado: boolean = false;
        public Cargando: boolean = false;
        public Guardando: boolean = false;
        public Error: boolean = false;

        public Ok()
        {
            return this.Contenido != this.Mensaje.Contenido || this.Activo != this.Mensaje.Activo;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;

            this.Contenido = '';
            this.UltimaModificacion = null;

            if ( !this.Mensaje )
                return;

            await Wait( 300 );
            this.Iniciado = true;
            this.UltimaModificacion = this.Mensaje.UpdatedAt;
            this.Contenido = this.Mensaje.Contenido;
            this.Activo = this.Mensaje.Activo;

            this.Cargando = false;
        }


        async Guardar()
        {
            this.Guardando = true;
            this.Mensaje.Contenido = this.Contenido;
            this.Mensaje.Activo = this.Activo;
            let e = await this.Mensaje.save();
            if ( e )
            {
                Utiles.Notificaciones.Completado( 'Guardado!' );
                this.UltimaModificacion = moment();
            } else
            {
                Utiles.Notificaciones.Error( 'Error al guardar!' );
                this.Error = true;
            }
            this.Guardando = false;
        }
    }
